var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-notification',{attrs:{"type":_vm.data.class,"closable":true},on:{"close":function($event){return _vm.$parent.close()}}},[_vm._v(" "+_vm._s(_vm.data.text)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }